export enum DocumentPublishingState {
  Unload = 0,
  Loading = 1,
  Loaded = 2,
  LoadingFailed = 3,
}
